<template lang="">
    <div class="ed-popup" v-click-outside="close">
        <span class="ed-popup__tip"></span>
        <div class="ed-popup__body">
            <h3 class="ed-popup__title"></h3>
            <p class="ed-popup__text"></p>
        </div>
        <box-icon name="x" title="close" class="box-icon ed-popup__close" @click="close"/>
    </div>
</template>
<script>
import clickOutside from '../directives/click-outside';

export default {
  name: 'ed-tooltip',
  directives: {
    clickOutside,
  },
  methods: {
    close() {
      document.querySelector('.ed-popup').style.display = 'none';
    },
  },
};
</script>
<style lang="scss">
.ed-popup {
  background-color: var(--white);
  color: var(--edvantaBlue);
  font-family: var(--fontFamily);
  /* border: 1px solid #adadad; */
  box-shadow: 0px 0px 0px 4px var(--white) inset, 0px 0px 0px 5px var(--color-grey-2) inset;
  position: fixed;
  display: none;
  padding: 2rem 2.5rem;
  max-width: 430px;
//   text-align: center;
  z-index: 10;
  &__tip {
    border: solid;
    border-color: var(--white) transparent;
    content: "";
    position: absolute;
    &--top {
      top: -10px;
      border-width: 0px 6px 12px 6px;
    }
    &--left {
      left: 5%;
    }
    &--bottom {
      border-width: 12px 6px 0 6px;
      bottom: -10px;
    }
    &--right {
      left: 95%;
    }
  }
  &__body {
    display: flex;
    align-items: baseline;
  }
    &__title {
        font-size: 1.1rem;
        margin-top: .1rem;
        &::after {
            content: ': ';
            margin-right: .5rem;
        }
    }
    &__text {
        margin: 0;
        // white-space: nowrap;
    }
  &__close {
    position: absolute;
    top: 4px;
    right: 4px;
  }
}
</style>
